import React from 'react';
import TiptapEditor from './TiptapEditor';

const ReactQuill = React.forwardRef((props, ref) => {
  const {
    value,
    onChange,
    placeholder,
    readOnly,
    theme,
    modules,
    formats,
    style,
    className,
    ...restProps
  } = props;

  return (
    <TiptapEditor
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      readOnly={readOnly}
      style={style}
      className={className}
      {...restProps}
    />
  );
});

ReactQuill.displayName = 'ReactQuill';

export default ReactQuill;
